import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const Phone = styled.span`
  color: ${ColorPalette.HEX.CharlestonGreen};
  font-size: 24px;
  line-height: 32px;
  margin-bottom: 24px;
`;

export const SuccessCircle = styled.img`
  margin: 0 auto 98px auto;
  width: 80px;
`;

export const Stores = styled.div`
  display: flex;
  justify-content: space-between;
  align-self: center;
  width: 340px;
  margin-top: 16px;
`;
